import { useState, useEffect } from 'react'

let counter = 1

export function useKeyToggle(targetKey: string): boolean {
  const [keyPressed, setKeyPressed] = useState<boolean>(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const downHandler = ({ key }: any) => {
    if (key === targetKey) {
      counter += 1
      setKeyPressed(counter % 2 === 0)
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', downHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  })

  return keyPressed
}
